import { render, staticRenderFns } from "./revenue-location.vue?vue&type=template&id=11bd4170"
import script from "./revenue-location.vue?vue&type=script&lang=js"
export * from "./revenue-location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports